import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '../../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    if (!isHomePage) {
      window.location.href = '/' + href;
      return;
    }
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        isScrolled ? 'bg-black/80 backdrop-blur-xl' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 group cursor-pointer">
            <img 
              src="https://customer-assets.emergentagent.com/job_coin-control-1/artifacts/2m2ji0tz_85e9384d-89d9-4ef4-b04a-b727bf317f00.jpg" 
              alt="Coin Bills Logo" 
              className="h-8 w-8 object-contain transition-transform duration-300 group-hover:scale-110"
            />
            <div className="flex flex-col leading-none elegant-underline">
              <span className="brand-font text-white/90 text-xs tracking-[0.15em] transition-all duration-300 group-hover:text-amber-400">COIN</span>
              <span className="brand-font text-white/90 text-xs tracking-[0.15em] transition-all duration-300 group-hover:text-amber-400">BILLS</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="text-white/50 hover:text-white text-xs font-medium tracking-[0.15em] transition-all duration-500 hover:tracking-[0.2em]"
              >
                {link.label}
              </button>
            ))}
            <Link
              to="/how-it-works"
              className="text-amber-500/80 hover:text-amber-400 text-xs font-medium tracking-[0.15em] transition-all duration-500 hover:tracking-[0.2em]"
            >
              HOW IT WORKS
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <button 
              onClick={() => scrollToSection('#contact')}
              className="px-6 py-2.5 text-xs font-medium tracking-[0.15em] border border-white/20 text-white/90 hover:bg-white hover:text-black transition-all duration-500 rounded-full"
            >
              ENQUIRE
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden overflow-hidden transition-all duration-500 ${
        mobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <div className="bg-black/95 backdrop-blur-xl border-t border-white/10">
          <nav className="flex flex-col py-6 px-6">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="text-white/60 hover:text-white text-sm font-medium tracking-[0.1em] py-4 text-left transition-colors duration-300 border-b border-white/5"
              >
                {link.label}
              </button>
            ))}
            <Link
              to="/how-it-works"
              onClick={() => setMobileMenuOpen(false)}
              className="text-amber-500/80 hover:text-amber-400 text-sm font-medium tracking-[0.1em] py-4 text-left transition-colors duration-300 border-b border-white/5"
            >
              HOW IT WORKS
            </Link>
            <button 
              onClick={() => scrollToSection('#contact')}
              className="mt-6 px-6 py-3 text-sm font-medium tracking-[0.1em] border border-white/20 text-white/90 hover:bg-white hover:text-black transition-all duration-300 rounded-full"
            >
              ENQUIRE
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
